// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a.btn-default,
.btn-default {
  color: #fff;
  text-decoration: none;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  background-color: #1eabe3;
  border: 1px solid #fff;
  font-size: 14px;
  padding: 1rem 5rem;
}

.btn-default,
.btn-default:active,
.btn-default:focus,
.btn-default:hover {
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  background-color: #1eabe3;
  border: 1px solid #fff;
  color: #fff;
  font-size: 14px;
  padding: 1rem 5rem;
}

/* Button styling */
button.btn-default {
  /* Remove all text shadows on buttons from now on.
     * bootstrap adds a text shadow automagically so we remove it. */
  text-shadow: initial;
}

/* Buttons for Navgation on TA Page*/

.btn-nav {
  background-color: white;
  border: 1px solid #d6d6d6;
  color: #a6a6a6;
  padding: 6px 26px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  border-radius: 0px;
  box-shadow: 1px 1px 9px #d6d6d6;
}

.btn-nav:hover {
  background-color: grey;
  color: white;
  text-decoration: none;
  font-weight: bold;
}

.btn-nav:active {
  color: white;
  background-color: grey;
  font-weight: bold;
  /*border-color: #494F57;*/
}

.btn-nav-search {
  width: 60px;
  height: 35px;
  margin-left: 7px;
  border-radius: 11px;
  font-weight: bold;
  background-color: #1eabe3;
  border-color: white;
}

.btn-filter-toggle {
  background-color: white;
  border: 1px solid #d6d6d6;
  color: #000000;
  padding: 4px 50px 4px 6px;
  text-align: left;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  border-radius: 0px;
  /*box-shadow: 1px 1px 9px #d6d6d6;*/
}

/* Used in the ta page course wizard
 * Puts a gray line on top of the next/previous/cancel buttons
 
 Use like so to create a border in a page
<div class="col-md-12 ">
    <div class="row grayTopBorder">
    </div>
</div>
 */
.graySeparator {
  border-top: 1px solid #e5e5e5;
  padding-top: 3rem;
  margin-top: 2rem;
  display: block;
  margin-left: 0;
  margin-right: 0;
}

/* Pill style buttons */
.btn.pill {
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 3px;
  padding: 3px 6px;
}

.btn.pill:before {
  content: 'x ';
  color: #000;
}

.new-student-button,
.new-student-button:active,
.new-student-button:focus,
.new-student-button:hover {
  font-size: 12px;
  padding-left: 2.25em;
  padding-right: 2.25em;
  border: none;
  border-radius: 10px;
  background-color: #1eabe3;
  color: white;
}

.btn-bottom-left {
  bottom: 0px;
  left: 0px;
  margin-bottom: 5px;
  margin-left: 5px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/buttons.css"],"names":[],"mappings":"AAAA;;EAEE,WAAW;EACX,qBAAqB;EACrB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;;EAIE,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE;oEACkE;EAClE,oBAAoB;AACtB;;AAEA,oCAAoC;;AAEpC;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;;;;;;;;EAQE;AACF;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;;;EAIE,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":["a.btn-default,\n.btn-default {\n  color: #fff;\n  text-decoration: none;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  background-color: #1eabe3;\n  border: 1px solid #fff;\n  font-size: 14px;\n  padding: 1rem 5rem;\n}\n\n.btn-default,\n.btn-default:active,\n.btn-default:focus,\n.btn-default:hover {\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  background-color: #1eabe3;\n  border: 1px solid #fff;\n  color: #fff;\n  font-size: 14px;\n  padding: 1rem 5rem;\n}\n\n/* Button styling */\nbutton.btn-default {\n  /* Remove all text shadows on buttons from now on.\n     * bootstrap adds a text shadow automagically so we remove it. */\n  text-shadow: initial;\n}\n\n/* Buttons for Navgation on TA Page*/\n\n.btn-nav {\n  background-color: white;\n  border: 1px solid #d6d6d6;\n  color: #a6a6a6;\n  padding: 6px 26px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  border-radius: 0px;\n  box-shadow: 1px 1px 9px #d6d6d6;\n}\n\n.btn-nav:hover {\n  background-color: grey;\n  color: white;\n  text-decoration: none;\n  font-weight: bold;\n}\n\n.btn-nav:active {\n  color: white;\n  background-color: grey;\n  font-weight: bold;\n  /*border-color: #494F57;*/\n}\n\n.btn-nav-search {\n  width: 60px;\n  height: 35px;\n  margin-left: 7px;\n  border-radius: 11px;\n  font-weight: bold;\n  background-color: #1eabe3;\n  border-color: white;\n}\n\n.btn-filter-toggle {\n  background-color: white;\n  border: 1px solid #d6d6d6;\n  color: #000000;\n  padding: 4px 50px 4px 6px;\n  text-align: left;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 14px;\n  border-radius: 0px;\n  /*box-shadow: 1px 1px 9px #d6d6d6;*/\n}\n\n/* Used in the ta page course wizard\n * Puts a gray line on top of the next/previous/cancel buttons\n \n Use like so to create a border in a page\n<div class=\"col-md-12 \">\n    <div class=\"row grayTopBorder\">\n    </div>\n</div>\n */\n.graySeparator {\n  border-top: 1px solid #e5e5e5;\n  padding-top: 3rem;\n  margin-top: 2rem;\n  display: block;\n  margin-left: 0;\n  margin-right: 0;\n}\n\n/* Pill style buttons */\n.btn.pill {\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 3px;\n  padding: 3px 6px;\n}\n\n.btn.pill:before {\n  content: 'x ';\n  color: #000;\n}\n\n.new-student-button,\n.new-student-button:active,\n.new-student-button:focus,\n.new-student-button:hover {\n  font-size: 12px;\n  padding-left: 2.25em;\n  padding-right: 2.25em;\n  border: none;\n  border-radius: 10px;\n  background-color: #1eabe3;\n  color: white;\n}\n\n.btn-bottom-left {\n  bottom: 0px;\n  left: 0px;\n  margin-bottom: 5px;\n  margin-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
